import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const ScentsSection = (): ReactElement => {
  const { t: tScents } = useTranslation('', { keyPrefix: '$pages.$home.$scentsSection' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.scentsSection' });

  return (
    <section className="base-section scents-section hp-section row-scents clearfix">
      <Link href={tLink('scent')} id="CTA-Scents">
        <div className="hp-top-text">
          <h2>
            <strong>{tScents('scentHeader_1')}</strong> <span>{tScents('scentHeader_2')}</span>
          </h2>
          <p>{tScents('scentDesc')}</p>
          <span className="btn-main">{tScents('shopScents')}</span>
        </div>
        <div className="scents-img">
          <picture>
            <img
              src="/images/homepage/renaissance-hotels-scent.png"
              alt="Renaissance Hotels Scents"
              width={1440}
              height={852}
              loading="lazy"
              decoding="async"
              fetchPriority="low"
            />
          </picture>
        </div>
        <div className="scents-left">
          <picture>
            <img
              src="/images/homepage/scent-black-bg.webp"
              alt="Scents"
              width={800}
              height={800}
              loading="lazy"
              decoding="async"
              fetchPriority="low"
            />
          </picture>
        </div>
        <div className="scents-right">
          <picture>
            <img
              src="/images/homepage/scents-video.gif"
              alt="Lilies blowing in the wind"
              width={450}
              height={450}
              loading="lazy"
              decoding="async"
              fetchPriority="low"
            />
          </picture>
        </div>
      </Link>
    </section>
  );
};

export default ScentsSection;
